angular.module('lf.common')

.directive('accordionToggle', function () {
  return {
    restrict: 'A',
    link: function (scope, el, attrs) {
      el.on('click', function () {
        el.toggleClass('expand');
      });
    }
  }
});
